import React from "react";
import StatisticReport from "../../components/StatisticsReport";

const MaterialDeliveryStats = () => {
	return <StatisticReport TYPE="Material Delivery" />;
};

export default MaterialDeliveryStats;
